export default __webpack_public_path__ + "static/media/left-circle.e0f20415.svg";